import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer';

/**
 * Create an instance of the GraphicsLayer and returns it
 * @param {Object} configs
 * @param {String} configs.id - the layer id
 * @param {Object} configs.point - the coordinates to draw the marker
 * @param {Url} configs.icon - the svg icon used for the marker
 */
export const createGraphicsLayer = async ({ configs }) => {
  if (!configs?.id) {
    throw Error('Must pass in a configs object with an id.');
  }

  return await handleLayer({ configs });
};

function handleLayer({ configs }) {
  return new GraphicsLayer(configs);
}
